/* eslint-disable import/no-extraneous-dependencies */
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import injectReducer from '../../../../utils/injectReducer';
import injectSaga from '../../../../utils/injectSaga';
import saga from '../../sagas.js';
import TermsandConditions from '../../../../components/Web/ReviewOrderPage/RedesignVDS3.0/tosIndex';
import * as tosActions from '../../actions';
import * as loaderActions from '../../../../components/common/Loader/action';
import tosReducer from '../../../TermsAndConditions/reducer';
import * as appointmentAction from '../../../AppointmentSchedule/actions';
import appointmentSaga from '../../../AppointmentSchedule/sagas';
import appointmentSchedule from '../../../AppointmentSchedule/reducer';
import { isFuncComp } from '../../../../components/common/Helpers/index.js';

const mapStateToProps = (state, ownProps) => {
  const installmentType =
    state.cartDetails && state.cartDetails.cartDetailsJson && state.cartDetails.cartDetailsJson.orderDetailsView
      ? state.cartDetails.cartDetailsJson.orderDetailsView.installType
      : {};
  const currentView = state.currentView || {};
  const isMobileTos = state.termsAndConditions && state.termsAndConditions.isMobileTos;
  const tosContent = state.termsAndConditions && state.termsAndConditions.tosContent;

  const enableContinueBtn = state.termsAndConditions && state.termsAndConditions.enableContinueBtn;
  const tos = isFuncComp()
    ? state?.checkout?.getCheckoutResponse?.data?.customerAgreement
    : state && state.termsAndConditions && state.termsAndConditions.data && state.termsAndConditions.data.customerAgreement;
  const dppTos = state && state.termsAndConditions && state.termsAndConditions.data && state.termsAndConditions.data.installment;
  const autoPayText = state && state.cartDetails && state.cartDetails.autoPayText;
  const appointmentScheduleState = state.appointmentSchedule || {};
  const creditReviewSuccessResponse = state.creditCheckDetails?.creditReviewSuccessResponse;
  const { networkBandwidthType, installType } = state.cartDetails?.cartDetailsJson?.orderDetailsView || {};
  const reviewOrderState = state.termsAndConditions;
  const { tosCheckBoxState, completeOrderButtonState } = reviewOrderState;
  return {
    ownProps,
    tos,
    currentView,
    installmentType,
    dppTos,
    enableContinueBtn,
    autoPayText,
    appointmentScheduleState,
    creditReviewSuccessResponse,
    isMobileTos,
    tosContent,
    networkBandwidthType,
    installType,
    reviewOrderState,
    tosCheckBoxState,
    completeOrderButtonState,
  };
};
function mapDispatchToProps(dispatch) {
  return bindActionCreators({ ...tosActions, ...appointmentAction, ...loaderActions }, dispatch);
}
const withReducer = compose(
  injectReducer({ key: 'tos', reducer: tosReducer }),
  injectReducer({ key: 'appointmentSchedule', reducer: appointmentSchedule }),
);

const withConnect = connect(mapStateToProps, mapDispatchToProps);

const withSaga = compose(injectSaga({ key: 'tos', saga }), injectSaga({ key: 'appointmentSchedule', saga: appointmentSaga }));
export default withRouter(compose(withSaga, withReducer, withConnect)(TermsandConditions));
